import { render, staticRenderFns } from "./MatrizIper.vue?vue&type=template&id=628bc8d8"
import script from "./MatrizIper.vue?vue&type=script&lang=js"
export * from "./MatrizIper.vue?vue&type=script&lang=js"
import style0 from "./MatrizIper.vue?vue&type=style&index=0&id=628bc8d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports